import { createTypedEnum } from '@reckon-web/formschema-enums';

export const TaskStatusEnum = createTypedEnum({
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  OnHold: 'OnHold',
  ReadyForReview: 'ReadyForReview',
  Done: 'Done',
  Cancelled: 'Cancelled',
} as const);
export type TaskStatusEnumValue = (typeof TaskStatusEnum.values)[number];
export type TaskStatusEnumLabel = (typeof TaskStatusEnum.labels)[number];
